import {trackEvent} from '@hconnect/common/logging/Analytics'
import {useUserContext} from '@hconnect/login'
import {useCallback} from 'react'

export const useTrackMaintainEvent = () => {
  const {loggedUser} = useUserContext()

  return useCallback(
    ({name}: {name: string}) =>
      loggedUser &&
      trackEvent(name, {
        userId: loggedUser.id,
        country: loggedUser.country,
        product: 'Maintain',
        subProduct: 'KMS'
      }),
    [loggedUser]
  )
}
